import { render, staticRenderFns } from "./EditDistrictPage.vue?vue&type=template&id=1ef2d6ae&"
import script from "./EditDistrictPage.vue?vue&type=script&lang=js&"
export * from "./EditDistrictPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports